const id_supplychain_distributionPoint = {
    "": "rantai pasokan",
    add: "tambah titik distribusi",
    edit: "ubah titik distribusi",

    label: {
        name: "Nama Titik Distribusi",
    },

    error: {
        create: "Gagal membuat titik distribusi",
        edit: "Gagal mengubah titik distribusi",
        name: "Nama titik distribusi tidak boleh kosong",
    },

    success: {
        create: "Berhasil membuat titik distribusi",
        edit: "Berhasil mengubah titik distribusi",
    },
}

export default id_supplychain_distributionPoint;